function IsDocReady(callbackFunction) {
    if (document.readyState !== 'loading') {
        callbackFunction(event);
    }
    else {
        document.addEventListener("DOMContentLoaded", callbackFunction);
    }
}
function ToggleCoupons(elem, sParentClassName, sChildClassName) {
    if (!elem) {
        return false;
    }
    //get parent
    var cur = elem.parentNode;
    while (cur) {
        if (cur && cur.className.indexOf(sParentClassName) !== -1) {
            break;
        }
        cur = cur.parentNode;
    }
    if (!cur) {
        return false;
    }
    //get child
    var arElems = cur.getElementsByClassName(sChildClassName);
    if (arElems && (arElems.length > 0)) {
        arElems[0].style.display = ((arElems[0].style.display === 'block') ? 'none' : 'block');
    }
}
function UpdateQuantity(sInputId, iVal) {
    var bUpdated = true;
    var elemInput = document.getElementById(sInputId);
    if (!elemInput || elemInput.type !== "number") {
        return false;
    }
    var iNewVal = parseInt(elemInput.value) + parseInt(iVal);
    var iMax = parseInt(elemInput.max);
    var iMin = parseInt(elemInput.min);
    if (((iMax >= 0) && (iNewVal > iMax)) || ((iMin >= 0) && (iNewVal < iMin))) {
        bUpdated = false;
    }
    else {
        elemInput.value = iNewVal;
    }
    return bUpdated;
}
function SubmitCartCoupon(sOrigId, sDestId, sBtnId) {
    var elemOrig = document.getElementById(sOrigId);
    var elemDest = document.getElementById(sDestId);
    var btnSubmit = document.getElementById(sBtnId);
    if (!elemOrig || !elemDest || !sBtnId) {
        return false;
    }
    elemDest.value = elemOrig.value;
    btnSubmit.click();
    return false;
}
function GetElementsByClassName(elem, sClassName) {
    return elem ? elem.getElementsByClassName(sClassName) : document.getElementsByClassName(sClassName);
}
function ToggleProductBundle(elem, sClassToShow) {
    if (!elem) {
        return false;
    }
    if (elem.className.indexOf('active') !== -1) {
        elem.className = elem.className.replace(/\s*active/gi, '');
        if (sClassToShow === 'show-bundle') {
            var arTmpElems = GetElementsByClassName(elem.parentNode, 'woosb_bundle');
            if (arTmpElems && (arTmpElems.length > 0)) {
                arTmpElems[0].parentNode.style.maxHeight = 0;
            }
        }
    }
    var arElems = elem.parentNode.getElementsByClassName(sClassToShow);
    if (arElems && (arElems.length > 0)) {
        for (var i = 0; i < arElems.length; i++) {
            if (arElems[i].className.indexOf('active') === -1) {
                if (sClassToShow === 'hide-bundle') {
                    var arTmpElems = GetElementsByClassName(arElems[i].parentNode, 'woosb_bundle');
                    if (arTmpElems && (arTmpElems.length > 0)) {
                        var iMarginTop = 0;
                        var tmpStyle = getComputedStyle(arTmpElems[0]);
                        if (tmpStyle.marginTop !== arTmpElems[0].style.marginTop) {
                            iMarginTop = tmpStyle.marginTop;
                        }
                        arTmpElems[0].parentNode.style.maxHeight = parseInt(arTmpElems[0].offsetHeight) + parseInt(iMarginTop) + 'px';
                    }
                }
                arElems[i].className += ' active';
            }
        }
    }
}
function ToggleCartPopup(sElemId, bShow) {
    var elem = document.getElementById(sElemId);
    if (!elem) {
        return;
    }
    if (bShow) {
        if (elem.className.indexOf('focus') === -1) {
            elem.className += ' focus';
        }
    }
    else {
        if (elem.className.indexOf('focus') !== -1) {
            elem.className = elem.className.replace(/\s*focus/gi, '');
        }
    }
}
function GetLabelForElement(elem) {
    if (!elem) {
        return false;
    }
    if (elem.parentNode && elem.parentNode.childNodes) {
        //first check for sibling label
        for (var i = 0; i < elem.parentNode.childNodes.length; i++) {
            if (!elem.parentNode.childNodes[i].tagName) {
                continue;
            }
            if ((elem.parentNode.childNodes[i].tagName.toLowerCase() === 'label') && (elem.parentNode.childNodes[i].htmlFor === elem.id)) {
                return elem.parentNode.childNodes[i];
            }
        }
    }
    else {
        var labels = document.getElementsByTagName("label");
        for (i = 0; i < labels.length; i++) {
            if (labels[i].htmlFor === elem.id) {
                return labels[i];
            }
        }
    }
    return false;
}
function GetLabelText(elem) {
    if (!elem) {
        return '';
    }
    if (elem.labels) {
        return elem.labels[0].innerText;
    }
    else {
        var label = GetLabelForElement(elem);
        if (label) {
            return label.innerText;
        }
    }
    return '';
}
function FormatElementHTML(elem, bShowLabel, sSeparator) {
    if (!elem) {
        return '';
    }
    var sHTML = '';
    var sElemType = elem.type.toLowerCase();
    if ((sElemType === 'text') || (sElemType === 'email') || (sElemType === 'tel') || (sElemType === 'textarea')) {
        if (bShowLabel) {
            sHTML += GetLabelText(elem) + sSeparator;
        }
        sHTML += elem.value;
    }
    else if (sElemType === 'select-one') {
        if (bShowLabel) {
            sHTML += GetLabelText(elem) + sSeparator;
        }
        if (elem.value !== '') {
            sHTML += elem.options[elem.selectedIndex].text;
        }
    }
    else if ((((sElemType === 'radio') || (sElemType === 'checkbox')) && elem.checked) || (sElemType === 'hidden')) {
        //in this case, label is treated as value
        sHTML += GetLabelText(elem);
    }
    return sHTML;
}
function DisplayFormElement(elem, bShowLabel, sSeparator) {
    if (!elem) {
        return;
    }
    var sHTML = '';
    if ((typeof elem.name === 'undefined') && (elem.length > 1)) {
        for (var i = 0; i < elem.length; i++) {
            sHTML += FormatElementHTML(elem[i], bShowLabel, sSeparator);
        }
    }
    else {
        sHTML = FormatElementHTML(elem, bShowLabel, sSeparator);
    }
    return sHTML.trim();
}
// TODO: third checkout step is disabled
// function ShowOrderSummary() {
//     var elem, form = null;
//
//     var arElems = document.getElementsByClassName('checkout-form');
//     if (arElems && (arElems.length > 0)) {
//         form = arElems[0];
//     }
//     if (!form) {
//         return;
//     }
//
//     SetCartHeaderStep(3);
//
//     //shipping details
//     elem = document.getElementById('order-shipping-details');
//     if (elem) {
//         elem.innerHTML = DisplayFormElement(form.elements.namedItem('shipping_method[0]'), true, ' - ');
//     }
//
//     //payment details
//     elem = document.getElementById('order-payment-details');
//     if (elem) {
//         elem.innerHTML = DisplayFormElement(form.elements.namedItem('payment_method'), true, ' - ');
//     }
//
//     //billing details
//     let sBillingHTML = '';
//     let sShippingHTML = '';
//     elem = document.getElementById('order-billing-details');
//     if (elem) {
//         var sTmp = '';
//         sTmp = DisplayFormElement(form.elements.namedItem('billing_name_or_company'), false, '');
//         if (sTmp !== '') {
//             sBillingHTML += sTmp + '<br>';
//             sShippingHTML += sTmp + '<br>';
//         }
//         sTmp = DisplayFormElement(form.elements.namedItem('billing_vat_number'), false, '');
//         if (sTmp !== '') {
//             sBillingHTML += sTmp + '<br>';
//         }
//         sTmp = DisplayFormElement(form.elements.namedItem('billing_address_1'), false, '');
//         if (sTmp !== '') {
//             sBillingHTML += sTmp + '<br>';
//             sShippingHTML += sTmp + '<br>';
//         }
//         sTmp = DisplayFormElement(form.elements.namedItem('billing_postcode'), false, '');
//         if (sTmp !== '') {
//             sBillingHTML += sTmp + '<br>';
//             sShippingHTML += sTmp + '<br>';
//         }
//         sTmp = DisplayFormElement(form.elements.namedItem('billing_city'), false, '');
//         if (sTmp !== '') {
//             sBillingHTML += sTmp + '<br>';
//             sShippingHTML += sTmp + '<br>';
//         }
//         sTmp = DisplayFormElement(form.elements.namedItem('billing_country'), false, '');
//         if (sTmp !== '') {
//             sBillingHTML += sTmp + '<br>';
//             sShippingHTML += sTmp + '<br>';
//         }
//         sTmp = DisplayFormElement(form.elements.namedItem('billing_email'), false, '');
//         if (sTmp !== '') {
//             sBillingHTML += sTmp + '<br>';
//         }
//         sTmp = DisplayFormElement(form.elements.namedItem('billing_phone'), false, '');
//         if (sTmp !== '') {
//             sBillingHTML += sTmp + '<br>';
//         }
//
//         elem.innerHTML = sBillingHTML;
//     }
//
//     elem = document.getElementById('order-shipping-address-details');
//     if (elem) {
//         //shipping address details
//         const elemDifferentAddress = document.getElementById('ship-to-different-address-checkbox') as any;
//         if (elemDifferentAddress && elemDifferentAddress.checked) {
//             sShippingHTML = '';
//             let sTmp = '';
//             sTmp = DisplayFormElement(form.elements.namedItem('shipping_first_name'), false, '');
//             if (sTmp !== '') {
//                 sTmp += ' ';
//             }
//             sTmp += DisplayFormElement(form.elements.namedItem('shipping_last_name'), false, '');
//             if (sTmp !== '') {
//                 sShippingHTML += sTmp.trim() + '<br>';
//             }
//
//             sTmp = DisplayFormElement(form.elements.namedItem('shipping_company'), false, '');
//             if (sTmp !== '') {
//                 sShippingHTML += sTmp + '<br>';
//             }
//             sTmp = DisplayFormElement(form.elements.namedItem('shipping_address_1'), false, '');
//             if (sTmp !== '') {
//                 sShippingHTML += sTmp + '<br>';
//             }
//             sTmp = DisplayFormElement(form.elements.namedItem('shipping_address_2'), false, '');
//             if (sTmp !== '') {
//                 sShippingHTML += sTmp + '<br>';
//             }
//             sTmp = DisplayFormElement(form.elements.namedItem('shipping_postcode'), false, '');
//             if (sTmp !== '') {
//                 sShippingHTML += sTmp + '<br>';
//             }
//             sTmp = DisplayFormElement(form.elements.namedItem('shipping_city'), false, '');
//             if (sTmp !== '') {
//                 sShippingHTML += sTmp + '<br>';
//             }
//             sTmp = DisplayFormElement(form.elements.namedItem('shipping_state'), false, '');
//             if (sTmp !== '') {
//                 sShippingHTML += sTmp + '<br>';
//             }
//             sTmp = DisplayFormElement(form.elements.namedItem('shipping_country'), false, '');
//             if (sTmp !== '') {
//                 sShippingHTML += sTmp + '<br>';
//             }
//         }
//         elem.innerHTML = sShippingHTML;
//     }
//
//     elem = document.getElementById('order-comments-details');
//     if (elem) {
//         var sHTML = DisplayFormElement(form.elements.namedItem('order_comments'), false, '');
//         if (sHTML.trim() !== '') {
//             elem.parentNode.style.display = 'block';
//             elem.innerHTML = sHTML;
//         } else {
//             elem.parentNode.style.display = 'none';
//         }
//     }
//
//     elem = document.getElementById('order-review-details');
//     if (elem) {
//         const elemOrderReview = document.getElementById('order_review');
//         if (elemOrderReview) {
//             elem.innerHTML = elemOrderReview.innerHTML;
//         }
//     }
//
//     elem = document.getElementById('tedee-order-confirmed');
//     if (elem) {
//         elem.value = 'yes';
//     }
//
//
//     arElems = document.getElementsByClassName('entry-title') as any;
//     if (arElems && (arElems.length > 0)) {
//         const item: any = arElems[0];
//         item.style.display = 'none';
//     }
//
//     elem = document.getElementById('order_summary_rows');
//     if (elem) {
//         elem.style.display = 'none';
//     }
//
//     elem = document.getElementById('order_summary_window');
//     if (elem) {
//         elem.style.display = 'flex';
//     }
// }
function CloseOrderSummary() {
    SetCartHeaderStep(2);
    var confirmedEl = document.getElementById('tedee-order-confirmed');
    if (confirmedEl) {
        confirmedEl.value = 'no';
    }
    var elem = document.getElementById('order_summary_window');
    if (elem) {
        elem.style.display = 'none';
    }
    var arElems = document.getElementsByClassName('entry-title');
    if (arElems && (arElems.length > 0)) {
        var item = arElems[0];
        item.style.display = 'block';
    }
    var summaryRows = document.getElementById('order_summary_rows');
    if (summaryRows) {
        summaryRows.style.display = 'flex';
    }
}
function SetCartHeaderStep(iCurStep) {
    var elem = document.getElementById('cart-header-steps');
    if (!elem) {
        return;
    }
    var arElems = elem.getElementsByClassName('step');
    if (arElems && (arElems.length > 0)) {
        iCurStep = parseInt(iCurStep);
        for (var i = 0; i < arElems.length; i++) {
            var iTmpStep = parseInt(arElems[i].getAttribute('data-step'));
            arElems[i].className = 'step';
            if (iTmpStep == iCurStep) {
                arElems[i].className += ' step-current';
            }
            else if (iTmpStep < iCurStep) {
                arElems[i].className += ' step-past';
            }
        }
    }
}
function CloseAddedToCartPopup(elem, sParentClassName) {
    if (!elem) {
        return;
    }
    //we actually destroy this window, not hide it
    var cur = elem.parentNode;
    while (cur) {
        if (cur && cur.className.indexOf(sParentClassName) !== -1) {
            break;
        }
        cur = cur.parentNode;
    }
    if (!cur) {
        return;
    }
    cur.parentNode.removeChild(cur);
}
function InitializeCartElements() {
    document.addEventListener('click', function (e) {
        var clickedEl = e.target;
        if (e.target && (typeof (clickedEl.className) == 'string')) {
            //submit cart coupon fix
            if (clickedEl.id === 'btn_dup_coupon') {
                SubmitCartCoupon('dup_coupon_code', 'coupon_code', 'apply_coupon');
            }
            //show coupons form
            if (clickedEl.id === 'toggle-coupons') {
                ToggleCoupons(clickedEl, 'coupons-wrapper', 'cart-coupons');
            }
            if (clickedEl.className.indexOf('hide-bundle') !== -1) {
                ToggleProductBundle(clickedEl, 'show-bundle');
            }
            if (clickedEl.className.indexOf('show-bundle') !== -1) {
                ToggleProductBundle(clickedEl, 'hide-bundle');
            }
            //cart popup
            if ((clickedEl.className.indexOf('cart-contents') !== -1)
                || (clickedEl.className.indexOf('widget_shopping_cart') !== -1)) {
                ToggleCartPopup('site-header-cart', true);
            }
            //close mini cart
            if (clickedEl.className.indexOf('close-mini-cart-overlay') !== -1) {
                ToggleCartPopup('site-header-cart', false);
            }
            //quantity + - buttons
            if (clickedEl.className.indexOf('number-change') !== -1) {
                var elem = e.target;
                var sTmpInputId = elem.getAttribute("data-rel-input");
                if (sTmpInputId) {
                    var bUpdated = false;
                    if (elem.value === '+') {
                        bUpdated = UpdateQuantity(sTmpInputId, 1);
                    }
                    else if (elem.value === '-') {
                        bUpdated = UpdateQuantity(sTmpInputId, -1);
                    }
                    if (bUpdated && elem.form.elements['update_cart']) {
                        //for some reason it's disabled by default, so enable it to be able to trigger the click
                        elem.form.elements['update_cart'].disabled = false;
                        elem.form.elements['update_cart'].click();
                    }
                }
            }
            //close summary overlay
            if (clickedEl.className.indexOf('close-window') !== -1) {
                CloseOrderSummary();
            }
            //close added to cart popup
            if (clickedEl.className.indexOf('close-added-to-cart-popup-link') !== -1) {
                CloseAddedToCartPopup(e.target, 'added-to-cart-wrapper');
            }
        }
    });
    document.addEventListener('change', function (e) {
        var clickedEl = e.target;
        if (clickedEl.className.indexOf('quantity-value') !== -1) {
            var elem = e.target;
            if (UpdateQuantity(elem.id, 0) && elem.form.elements['update_cart']) {
                //for some reason it's disabled by default, so enable it to be able to trigger the click
                elem.form.elements['update_cart'].disabled = false;
                elem.form.elements['update_cart'].click();
            }
        }
    });
    // jQuery(document.body).on('checkout_error', function () {
    //     const arNodes = document.querySelectorAll('.woocommerce-error li');
    //     let iErrorCount = 0;
    //     if (arNodes && arNodes.length > 0) {
    //         for (let i = 0; i < arNodes.length; i++) {
    //             if (arNodes[i].getAttribute('data-hide')) {
    //                 continue;
    //             }
    //             iErrorCount++;
    //         }
    //     }
    //
    //     if (iErrorCount === 0) {
    //         var elem = document.querySelector('.woocommerce-error');
    //         elem.parentNode.removeChild(elem);
    //         ShowOrderSummary();
    //     }
    // });
    if (!document.getElementsByClassName('vi-wcaio-sidebar-cart-wrap').length)
        jQuery(document.body).on('added_to_cart', function (event, fragments, cart_hash, button) {
            button.after('<div id="added-to-cart-loader" class="added_to_cart loading"></div>');
            jQuery.ajax({
                url: '/wp/wp-admin/admin-ajax.php',
                data: {
                    'action': 'get_added_to_cart_popup',
                    'product_id': button.data('product_id')
                },
                success: function (data) {
                    var elem = document.getElementById('added-to-cart-loader');
                    if (elem) {
                        elem.parentNode.removeChild(elem);
                    }
                    if (data) {
                        button.after(data);
                    }
                }
            });
        });
}
IsDocReady(InitializeCartElements());
